@import "./offset-teaser.default.scss";

.#{$prefix}offset-teaser-wrapper {
  display: grid;
  grid-template-columns: repeat(12, [col-start] 1fr);

  @include for-size(desktop-or-larger) {
    grid-column-gap: 32px;
  }

  // Value refered only to desktop screens' layout. (Declared in this scope because we need to
  // access the value in content-layer since the main headline is inside it instead of image-layer.
  $imageHorizontalOffset: 48px;
  $imageVerticalOffset: 52px;
  $imageBottomPaddingWithContent: 48px;

  @include for-size(phone) {
    grid-template-columns: 100%;
    grid-template-areas:
      "image"
      "content";
  }

  .#{$prefix}image-layer {
    width: 100%;
    z-index: 3;
    grid-column: col-start / span 7;

    @include for-size(desktop-or-larger) {
      top: $imageHorizontalOffset;
      // By defining the row explicitly we make image and backgrouns to overlap each other, otherwise the gris would wrap in two rows.
      grid-row: 1;
      padding-bottom: $imageVerticalOffset + $imageBottomPaddingWithContent;
    }

    @include for-size(tablet) {
      grid-column: col-start / span 12;
    }

    @include for-size(phone) {
      grid-column: image;
      right: 0;
      margin-bottom: 0;
    }

    .#{$prefix}offset-teaser-headline {
      position: absolute;
      color: $eon-bright;
      z-index: 1;
      top: 48px;
      right: 48px;
      width: 75%;
      @include for-size(desktop) {
        top: 40px;
        right: 40px;
      }
    }

    .#{$prefix}image-wrapper {
      &.#{$prefix}ratio-2x1 {
        &::after {
          @include aspect-ratio(2, 1);
        }
      }

      &.#{$prefix}ratio-4x3 {
        &::after {
          @include for-size(phone) {
            @include aspect-ratio(4, 3);
          }
        }
      }

      .#{$prefix}color-bar {
        height: 100%;
        z-index: 1;
        position: absolute;
        left: 0;

        @include for-size(phone) {
          width: 8px;
          &.#{$prefix}offset-bar {
            left: 16px;
          }
        }

        @include for-size(tablet) {
          width: 16px;
          &.#{$prefix}offset-bar {
            left: 32px;
          }
        }
      }
    }
  }

  .#{$prefix}content-layer {
    width: 100%;
    grid-column: col-start 7 / -1;
    justify-content: initial;
    min-height: unset;

    .#{$prefix}visible-background {
      @include borderRadius("variant_three", "content");
      @include boxShadow("variant_three", "content");
    }

    @include for-size(desktop-or-larger) {
      // By defining the row explicitly we make image and backgrounds to overlap each other, otherwise the gris would wrap in two rows.
      grid-row: 1;
    }

    @include for-size(tablet) {
      transform: translateY(-40px);
      z-index: 3;
    }

    @include for-size(phone) {
      grid-column: content;
    }

    .#{$prefix}content-wrapper {
      padding: 40px 32px 48px 80px;
      width: 100%;
      z-index: 5;
      display: flex;
      flex-direction: column;
      justify-content: center;

      @include for-size(desktop-l-or-larger) {
        // This compensates the overlapping of image with the background block. That overlapping is
        // one grid column wide and content wrapper has six columns width so 1/6th.
        margin-left: calc(16.67% - 32px);
        padding: 48px;
      }

      @include for-size(desktop) {
        // This compensates the overlapping of image with the background block. That overlapping is
        // one grid column wide and content wrapper has six columns width so 1/6th.
        margin-left: calc(16.67% - 25px);
      }

      @include for-size(desktop) {
        padding: 48px 32px;
      }

      @include for-size(tablet) {
        width: 100%;
        padding: 40px 32px 44px 32px;
      }

      @include for-size(phone) {
        width: 100%;
        padding: 32px 24px 44px 24px;
      }

      .#{$prefix}offset-teaser-headline {
        $headlinePaddingRight: 40px;
        $contentTopPaddingTablet: 40px;
        $headlineOffsetFromImageTablet: 40px;
        position: absolute;
        width: calc(75% + 32px);
        white-space: inherit;

        @include for-size(desktop-or-larger) {
          display: none;
        }
        @include for-size(tablet) {
          right: calc(100% + #{$headlinePaddingRight});
          top: $contentTopPaddingTablet + $headlineOffsetFromImageTablet;
          color: v(headlineColorOffset);
        }
        @include for-size(phone) {
          position: relative;
          width: auto;
          padding-bottom: 24px;
          color: v(headlineColor);
        }
      }
    }
  }
}
::slotted(p) {
  @include eon-typography("copy");
}
::slotted(eon-ui-image) {
  @include borderRadius("variant_three", "image");
  @include boxShadow("variant_three", "image");
}
